import React from "react";
import PropTypes from "prop-types";
import LayoutV2 from "containers/LayoutV2";
import "react-dropdown/style.css";
import ReactDropdown from "react-dropdown";
import SearchNoPhaiThu from "components/CommonComponent/SearchNoPhaiThu";
import { Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { catChuoi } from "utils/stringExtension";
import { ChoVayCombo } from "constants/choVayConst";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { getDate } from "utils/formatDate";
import { formatNumber, nFormatter, formatMoney } from "utils/currencyFormat";
import { LaiSuatText } from "constants/choVayConst";
import ButtonChuyenForm from "components/CommonComponent/ButtonChuyenForm";
import TatToanContainer from "containers/Common/QuanLyChoVay/TatToanContainer";
import DongLaiContainer from "containers/Common/QuanLyChoVay/dongLai";
import InThuChiContainer from "containers/Common/ThuChi/InThuChiContainer";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import GuiEmailContainer from "containers/Common/QuanLyChoVay/GuiEmailContainer";
import TinNhanContainer from "containers/Common/QuanLyChoVay/TinNhanContainer";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import { currentDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import GiaHanNoPhaiThuContainer from "containers/NoPhaiThu/GiaHanNoPhaiThuContainer";
import parse from "html-react-parser";
import GhiChuChoVayContainer from "containers/NoPhaiThu/GhiChuChoVayContainer";
import { API_AUTH } from "service/common";
import configs from "constants/configs";
import PrintData from "components/GenericComponent/PrintData";
import ChiTietTaiSanContainer from "containers/Common/TaiSan/ChiTietTaiSanContainer";
import GoiPhanMemApi from "../../service/goiPhanMemApi";
import { BtnXuatExcel } from "./BtnXuatExcel";
import { BtnInDanhSach } from "./BtnInDanhSach";
import { Cookies } from "react-cookie";
import { ModalThongBaoKhiDangNhap } from "components/ThongBaoKhiDangNhap";
import userApi from "service/userApi";
import thongBaoThongTinVayApi from "service/ChoThongTin/thongBaoThongTinVayApi";
import { ModalSuaKyLai } from "components/CommonComponent/DongLai/SuaKyLai/ModalSuaKyLai";
import { ModalInDanhSachDongLai } from "components/CommonComponent/DongLai/InDanhSachDongLai/ModalInDanhSachDongLai";
import ChiTietCuaHangApi from "service/chiTietCuaHangApi";
import moment from "moment";
import { ModalThongBaoHetHan } from "./ModalThongBaoHetHan";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import CauHinhApi from "../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";
import DoiTinhTrangNoContainer from "containers/Common/QuanLyChoVay/DoiTinhTrangNoContainer";
import { formatCurrency } from "utils/currencyFormat";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";

class NoPhaiThu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGhiChu: false,
      showTKNangCao: false,
      showGiaHanNoPhaiThu: false,
      showModalTaiSan: false,
      showThongBaoHetHan: false,
      dateHetHan: null,
      dataSearch: {
        dateTo: null,
        code: "",
        customerName: "",
        address: "",
        debt: "-1",
        userName: "0",
        trangThaiGiaHan: "0",
        kieuvay: "0",
        tienVay: "",
        typeNgayPhaiTra: "0",
        optionDateMB: "",
        manhanvien: "",
        pageIndex: 1,
        pageSize: 20,
        sapxep: 0,
      },
      choVay: {},
      taiSanId: 0,
      showSendMail: 0,
      showModalThongBao: false,
      isShowSuaKyLai: false,
      dataSuaKyLai: {},
      isShowInDanhSachDongLai: false,
      dataInDanhSachDongLai: {},
      dataTotalDongLai: {},
      isQRThanhToan: false,
      TienThanhToan: 0,
      isShowModalQRThanhToanHD: false,
      itemDataQR: {},
      isCauHinhKhachHangBinhAn: false,
      showDoiTinhTrangNo: false,
      isShowModalThietLapHienThi: false,
      objThietLapHienThiDanhSach: {},
      listTinhTrangNo: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      listNhanVien: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
    };
  }
  componentDidMount() {
    document.title = "Nợ phải thu | Phần mềm quản lý cầm đồ Morman";
    let { getComboUser, getPhanQuyenNoPhaiThu, getConfig } = this.props;
    let { dataSearch, showSendMail } = this.state;

    getComboUser();
    getPhanQuyenNoPhaiThu();
    getConfig();
    this.getThietLapHienThi();
    GoiPhanMemApi.GoiPhanMemNoPhaiThu().then((response) => {
      if (response.status == 200) {
        showSendMail = response.data.ShowSendEmail;
        this.setState({ showSendMail });
      }
    });

    userApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data.map((item) => ({
          value: item.value == "0" ? "" : item.value,
          label: item.label,
        }));
        this.setState({ listNhanVien: users });
      }
    });

    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        this.setState(
          { listTinhTrangNo: dataComboTinhTrangNew },
          this.getConfigKey
        );
      }
    });
  }
  getThietLapHienThi() {
    ThietLapHienThiApi.thietLapDanhSachNoPhaiThu().then((response) => {
      this.setState({ objThietLapHienThiDanhSach: response.data });
    });
  }
  getConfigKey() {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase()
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
          let { dataSearch, showSendMail } = this.state;
          const configNangCapKhachHangBinhAn = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHBinhAn.toUpperCase()
          );
          if (configNangCapKhachHangBinhAn != null) {
            if (configNangCapKhachHangBinhAn.valueConfig === "1") {
              dataSearch.debt = "999";
              this.setState({ isCauHinhKhachHangBinhAn: true });
              this.setState({ dataSearch });
            }
          }
          this.loadNoPhaiThu(dataSearch);
        }
      }
    });
  }

  toggleModalHetHan() {
    this.setState({ showThongBaoHetHan: !this.state.showThongBaoHetHan });
  }

  getNhanVienLabel = (value) => {
    const { listNhanVien } = this.state;
    if (!Array.isArray(listNhanVien) || value === "") return value;
    const found = listNhanVien.find((nv) => nv.value === value);
    return found ? found.label : value;
  };

  componentDidUpdate() {
    let { phanquyen } = this.props;
    let { PhanQuyenNoPhaiThu, getPhanQuyenSuccess } = phanquyen;
    let { nophaithu_danhsachnophaithu } = PhanQuyenNoPhaiThu;
    if (
      getPhanQuyenSuccess &&
      (typeof nophaithu_danhsachnophaithu === "undefined" ||
        nophaithu_danhsachnophaithu === false)
    ) {
      window.location.href = configs.errorLink;
    }
  }

  toggleModal() {
    this.setState({ showModalThongBao: !this.state.showModalThongBao });
  }
  toggleModalQRThanhToanHD() {
    this.setState({
      isShowModalQRThanhToanHD: !this.state.isShowModalQRThanhToanHD,
    });
  }
  loadNoPhaiThu(dataSearch) {
    let { getListNoPhaiThu } = this.props;
    getListNoPhaiThu(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  setTKNangCaoModalShow = (dataSearch) => {
    this.setState({ showTKNangCao: !this.state.showTKNangCao });
    if (dataSearch && dataSearch && this.state.showTKNangCao) {
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  setModalGhiChuShow = (choVay) => () => {
    let { showModalGhiChuChoVay } = this.props;
    if (choVay) this.setState({ choVay });
    showModalGhiChuChoVay();
    if (!choVay) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  setModalQRThanhToanShow = (hopdong) => () => {
    this.setState({ itemDataQR: hopdong });
    this.setState({ TienThanhToan: hopdong.Value });
    this.toggleModalQRThanhToanHD();
  };
  setModalDoiTinhTrangNoShow = (choVay) => () => {
    let { showDoiTinhTrangNo } = this.state;
    if (choVay)
      this.setState({ choVay, showDoiTinhTrangNo: !showDoiTinhTrangNo });
    if (this.state.showDoiTinhTrangNo) {
      let { dataSearch } = this.state;

      this.loadNoPhaiThu(dataSearch);
    }
  };
  setModalTatToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTatToan } = this.state;
    if (data)
      this.setState({
        showTatToan: !showTatToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
      });
    else this.setState({ showTatToan: !showTatToan });
    if (showTatToan) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  setModalGiaHanNoPhaiThuShow = (choVay) => () => {
    let { showModalGiaHanNoPhaiThu } = this.props;
    if (choVay) this.setState({ choVay });
    showModalGiaHanNoPhaiThu();
    if (!choVay) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  selectRow = (item) => () => {
    this.setState({ choVay: item });
  };
  setDongLaiModalShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    if (data)
      this.setState({
        showDongLai: !this.state.showDongLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTatToan: false,
      });
    else this.setState({ showDongLai: !this.state.showDongLai });
    if (this.state.showDongLai) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };

  setSuaKyLaiModalShow = (data, obj) => () => {
    this.setState({
      isShowSuaKyLai: !this.state.isShowSuaKyLai,
      dataSuaKyLai: data,
      dataTotalDongLai: obj,
    });
  };

  setInDanhSachDongLaiShow = (data) => () => {
    this.setState({
      isShowInDanhSachDongLai: !this.state.isShowInDanhSachDongLai,
      dataInDanhSachDongLai: data,
    });
  };

  setModalChiTietKhachHangShow = (choVay) => () => {
    let { showChiTietKhachHang } = this.state;
    if (choVay)
      this.setState({ showChiTietKhachHang: !showChiTietKhachHang, choVay });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
  };
  setModalChiTietHopDongShow = (choVay) => () => {
    let { showChiTietHopDong } = this.state;
    if (choVay)
      this.setState({ choVay, showChiTietHopDong: !showChiTietHopDong });
  };

  setModalTaiSan = (taiSanId) => () => {
    let { showModalTaiSan } = this.state;
    this.setState({ taiSanId, showModalTaiSan: !showModalTaiSan });
  };

  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadNoPhaiThu(dataSearch);
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    if (field === "typeNgayPhaiTra") {
      if (value.value === "1") {
        dataSearch.optionDateMB = currentDate();
      }
      var date = new Date();
      if (value.value === "2") {
        date = date.addDays(-1);
        dataSearch.optionDateMB = formatDayMonth(date);
      }
      if (value.value === "3") {
        date = date.addDays(1);
        dataSearch.optionDateMB = formatDayMonth(date);
      }
      if (value.value === "0") {
        dataSearch.optionDateMB = "";
      }
    }
    this.setState({ dataSearch });
  };
  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadNoPhaiThu(dataSearch);
  };
  renderTableRows() {
    let { nophaithu, phanquyen, showModalGuiEmail, showModalGuiTinNhan } =
      this.props;
    let { choVay, showSendMail, isQRThanhToan, objThietLapHienThiDanhSach } =
      this.state;
    let isShow = false;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches;
    }
    let { PhanQuyenNoPhaiThu } = phanquyen;
    let {
      nophaithu_tattoannophaithu,
      nophaithu_thanhtoannophaithu,
      nophaithu_guiemail,
      nophaithu_nhantin,
      nophaithu_ghichunophaithu,
      nophaithu_giahannophaithu,
      nophaithu_thongtinchitiethopdong,
      nophaithu_thongtinchitietkhachhang,
      nophaithu_laisuat,
      nophaithu_suatientattoan,
      SuDungMaNhanVien,
      nophaithu_doitinhtranghopdong,
    } = PhanQuyenNoPhaiThu;
    let date = convertDate(currentDate());
    return nophaithu.objList.List.map((item, index) => {
      let NoteTitle = "";
      if (item.NoteCV) NoteTitle += "Ghi chú: " + item.NoteCV;
      if (item.NoteGiaHan) NoteTitle += "Gia hạn: " + item.NoteGiaHan;
      let ngayTra = convertDate(item.NgayTra);
      let msgGoc = "";
      if (ngayTra <= date) {
        if (formatDayMonth(ngayTra) === formatDayMonth(date))
          msgGoc = "Hôm nay trả gốc";
        if (ngayTra < date) msgGoc = "Quá hạn trả gốc";
      }
      return (
        <div
          className={
            "custom-new custom-table-row " +
            (item === choVay && !isShow ? "active" : "")
          }
          key={"item" + index}
          onClick={this.selectRow(item)}
        >
          {item.DebtLevel === 50 && (
            <span className="line-job-color job-color-picker-1"></span>
          )}
          {item.DebtLevel === 20 && (
            <span className="line-job-color job-color-picker-2"></span>
          )}
          {item.DebtLevel === 30 && (
            <span className="line-job-color job-color-picker-3"></span>
          )}
          {item.DebtLevel === 40 && (
            <span className="line-job-color job-color-picker-4"></span>
          )}
          {objThietLapHienThiDanhSach.IsAnSTT != true && (
            <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm-npt flex-basis-6-npt disk-mobile">
              <span className="mobile-column-name color7-bold">STT</span>
              <div className="center-wrapper">
                <p className="text-center color7">{item.IndexId}</p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnMaHD != true && (
            <div className="custom-table-cell flex-basis-11 flex-basis-11-6-sm-npt flex-basis-10-6-npt center-flex">
              <span className="mobile-column-name color7-bold ">
                Mã hợp đồng
              </span>
              <div className="center-wrapper">
                <span className="profile_name center-flex  word-break ">
                  {nophaithu_thongtinchitiethopdong ? (
                    <a
                      id=""
                      href={() => false}
                      onClick={this.setModalChiTietHopDongShow(item)}
                      className="blue btn-link"
                    >
                      {item.Code}
                    </a>
                  ) : (
                    item.Code
                  )}
                </span>
                <span className="font-lai color7">
                  <br />
                  {getDate(item.NgayVay)}
                  <br />
                  {getDate(item.NgayTra)}
                </span>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnTSTheChap != true && (
            <div className="custom-table-cell flex-basis-10 flex-basis-9-sm">
              <span className="mobile-column-name color7-bold">
                TS thế chấp
              </span>
              <div className="center-wrapper color7">
                <p className="text-left" title={item.TaiSan}>
                  {catChuoi(item.TaiSan, 10)}
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnTenKH != true && (
            <div className="custom-table-cell flex-basis-12  flex-basis-11-8-sm-npt flex-basis-11-8-npt">
              <span className="mobile-column-name color7-bold">
                Tên khách hàng
              </span>
              <div className="center-wrapper color7">
                <p>
                  {nophaithu_thongtinchitietkhachhang ? (
                    <a
                      id=""
                      href={() => false}
                      className="blue btn-link"
                      onClick={this.setModalChiTietKhachHangShow(item)}
                    >
                      {item.CustomerName}
                    </a>
                  ) : (
                    item.CustomerName
                  )}

                  <br />
                  {item.phoneCus && (
                    <span title={item.phoneCus} class="font-lai">
                      {" "}
                      {catChuoi(item.phoneCus, 10)}
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
            SuDungMaNhanVien && (
              <div className="custom-table-cell flex-basis-6 flex-basis-11-sm-npt flex-basis-8-8-npt">
                <span className="mobile-column-name color7-bold">
                  Nhân viên
                </span>
                <div className="center-wrapper">
                  {/* <p className="text-right">{formatNumber(item.TienLaiConNo)}</p> */}
                  <p
                    className="text-center text-truncate"
                    style={{
                      maxWidth: "80px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      margin: 0,
                    }}
                    title={this.getNhanVienLabel(item.MaNhanVien)}
                  >
                    {this.getNhanVienLabel(item.MaNhanVien)}
                  </p>
                </div>
              </div>
            )}
          {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
            this.state.isCauHinhKhachHangBinhAn == false && (
              <div className="custom-table-cell flex-basis-11 flex-basis-11-sm-npt flex-basis-10-8-npt">
                <span className="mobile-column-name color7-bold">
                  Số tiền vay
                </span>
                <div className="center-wrapper">
                  <p className="text-right">
                    <span className="fontnew-500 color-do-bold">
                      {formatNumber(item.Sotienvay)}
                    </span>{" "}
                    <br />{" "}
                    {nophaithu_laisuat && item.Type !== 2 && (
                      <>
                        {item.IsDuNoGiamDan == true && (
                          <span className="font-lai color7">
                            (
                            {"Chi phí vay: " +
                              formatMoney(item.ChiPhiVay, 2) +
                              "%"}
                            )
                          </span>
                        )}
                        {(item.IsDuNoGiamDan == undefined ||
                          item.IsDuNoGiamDan == false) && (
                          <span className="font-lai color7">
                            (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                          </span>
                        )}
                      </>
                    )}
                    {/* {item.Type !== 2 && (
                  <span className="font-lai">
                    (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                  </span>
                )} */}
                    {nophaithu_laisuat && item.Type === 2 && (
                      <span className="font-lai color7">
                        (
                        {/* {item.StatusPaidHo === 1
                      ? 'Lãi thiếu: ' +
                      nFormatter(item.ValueLai * item.CountTypePaid)
                      : 'Lãi đủ: ' +
                      nFormatter(item.ValueLai * item.BocTrongVong)} */}
                        {item.StatusPaidHo === 1 &&
                          "Lãi thiếu: " +
                            nFormatter(
                              Math.ceil(item.ValueLai * item.CountTypePaid)
                            )}
                        {item.StatusPaidHo === 2 &&
                          "Lãi đủ: " +
                            nFormatter(item.ValueLai * item.BocTrongVong)}
                        {item.StatusPaidHo === 3 &&
                          "Chi phí vay: " +
                            formatMoney(item.ChiPhiVay, 2) +
                            "%"}
                        )
                      </span>
                    )}
                  </p>
                </div>
              </div>
            )}
          {this.state.isCauHinhKhachHangBinhAn == true && (
            <div className="custom-table-cell flex-basis-11 flex-basis-11-sm-npt flex-basis-10-8-npt">
              <span className="mobile-column-name color7-bold">
                Tiền đưa khách
              </span>
              <div className="center-wrapper">
                <p className="text-right">
                  <span className="fontnew-500">
                    {formatNumber(item.Sotienvay)}
                  </span>
                  <br />{" "}
                  {nophaithu_laisuat && item.Type !== 2 && (
                    <>
                      {item.IsDuNoGiamDan == true && (
                        <span className="font-lai">
                          (
                          {"Chi phí vay: " +
                            formatMoney(item.ChiPhiVay, 2) +
                            "%"}
                          )
                        </span>
                      )}
                      {(item.IsDuNoGiamDan == undefined ||
                        item.IsDuNoGiamDan == false) && (
                        <span className="font-lai">
                          (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                        </span>
                      )}
                    </>
                  )}
                  {nophaithu_laisuat && item.Type === 2 && (
                    <span className="font-lai">
                      (
                      {item.StatusPaidHo === 1 &&
                        "Lãi thiếu: " +
                          nFormatter(
                            Math.ceil(item.ValueLai * item.CountTypePaid)
                          )}
                      {item.StatusPaidHo === 2 &&
                        "Lãi đủ: " +
                          nFormatter(item.ValueLai * item.BocTrongVong)}
                      {item.StatusPaidHo === 3 &&
                        "Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                      )
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnNoLai != true && (
            <div className="custom-table-cell flex-basis-11 flex-basis-11-sm-npt flex-basis-11-4-npt">
              <span className="mobile-column-name color7-bold">Nợ lãi</span>
              <div className="center-wrapper">
                <p className="text-right color-xanh-bold">
                  {formatNumber(item.TienLaiConNo)}
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnPhiHangKy != true && (
            <div className="custom-table-cell flex-basis-9 flex-basis-9-sm-npt flex-basis-9-4-npt">
              <span className="mobile-column-name color7-bold">
                Phí hàng kỳ
              </span>
              <div className="center-wrapper">
                <p className="text-right color-tim-bold">
                  {formatNumber(item.TienPhiKhacHangKy)}
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnNoGoc != true && (
            <div className="custom-table-cell flex-basis-9 flex-basis-11-sm-npt flex-basis-11-2-npt">
              <span className="mobile-column-name color7-bold">Nợ gốc</span>
              <div className="center-wrapper">
                <p className="text-right color-cam-bold">
                  <span className="">{formatNumber(item.TienGocConNo)}</span>
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnTongNo != true && (
            <div className="custom-table-cell flex-basis-11 flex-basis-11-sm-npt flex-basis-11-8-npt">
              <span className="mobile-column-name color7-bold">Tổng nợ</span>
              <div className="center-wrapper">
                <p className="text-right color-do-bold">
                  <span className="">{formatNumber(item.Value)}</span>
                </p>
              </div>
            </div>
          )}
          {objThietLapHienThiDanhSach.IsAnLyDo != true && (
            <div className="custom-table-cell flex-basis-10 flex-basis-11-2-sm-npt flex-basis-8-4-npt">
              <span className="mobile-column-name color7-bold">Lý do</span>
              <div className="center-wrapper">
                <p className="text-left color-tim-bold">
                  {item.NgaySapNo < 0 && (
                    <>
                      {item.Type === 2 && (
                        <span className="text-lai-mm">
                          Chậm {item.SoKyConNoTuTruocToiNay} Kỳ góp (
                          {item.NgayNoLaiFist} Ngày).
                        </span>
                      )}
                      {item.Type !== 2 && (
                        <span className="text-lai-mm">
                          Chậm {item.SoKyConNoTuTruocToiNay} Kỳ lãi (
                          {item.NgayNoLaiFist} Ngày).
                        </span>
                      )}
                    </>
                  )}
                  {item.NgaySapNo === 0 && (
                    <>
                      <span className="text-lai-mm">Đến hạn đóng lãi</span>
                    </>
                  )}
                  {item.NgaySapNo > 0 && (
                    <>
                      <span className="text-lai-mm">
                        {item.NgaySapNo} ngày sau đến hạn
                      </span>
                    </>
                  )}

                  {msgGoc && <span className="text-lai-mm">{msgGoc}</span>}
                  {NoteTitle && (
                    <span>
                    
                        <PopoversBootrap
                          contentText={parse(parse(NoteTitle))}
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"left"}
                        >
                          <i class="fas fa-info-circle" style={{color:"red"}}></i>
                        </PopoversBootrap>
                   
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}

          {objThietLapHienThiDanhSach.IsAnChucNang != true && (
            <div className="custom-table-cell flex-basis-8 flex-basis-7-sm-npt flex-basis-7-npt  action-cell">
              <div className="center-wrapper">
                <div className="iconTableMormanCenter text-center">
                  {nophaithu_thanhtoannophaithu && (
                    <a
                      href={() => false}
                      onClick={this.setDongLaiModalShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Đóng lãi"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="dong-lai-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}
                  {nophaithu_tattoannophaithu && (
                    <a
                      href={() => false}
                      onClick={this.setModalTatToanShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Tất toán"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="tat-toan-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}
                  <div className="hidden-des-main">
                    {nophaithu_giahannophaithu && (
                      <a
                        className="dropdown-item"
                        onClick={this.setModalGiaHanNoPhaiThuShow(item)}
                        href={() => false}
                      >
                        <PopoversBootrap
                          contentText="Gia hạn"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-gia-han.png" />
                        </PopoversBootrap>
                      </a>
                    )}

                    {nophaithu_nhantin && (
                      <a
                        className="dropdown-item"
                        href={() => false}
                        onClick={showModalGuiTinNhan}
                      >
                        <PopoversBootrap
                          contentText="Nhắn tin"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-tin-nhan.png" />
                        </PopoversBootrap>
                      </a>
                    )}

                    {nophaithu_guiemail && showSendMail == 1 && (
                      <a
                        className="dropdown-item"
                        href={() => false}
                        onClick={showModalGuiEmail}
                      >
                        <PopoversBootrap
                          contentText="Gửi Email"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-gui-mail.png" />
                        </PopoversBootrap>
                      </a>
                    )}
                    {nophaithu_ghichunophaithu && (
                      <a
                        className="dropdown-item"
                        onClick={this.setModalGhiChuShow(item)}
                        href={() => false}
                      >
                        <PopoversBootrap
                          contentText="Ghi chú"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-ghi-chu.png" />
                        </PopoversBootrap>
                      </a>
                    )}

                    {isQRThanhToan && (
                      <a
                        className="dropdown-item"
                        onClick={this.setModalQRThanhToanShow(item)}
                        href={() => false}
                      >
                        <PopoversBootrap
                          contentText="QR thanh toán"
                          titleText=""
                          trigger={["hover", "focus"]}
                          placement={"top"}
                        >
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </PopoversBootrap>
                      </a>
                    )}
                  </div>

                  <Dropdown className="DropNew trangthai-new dropdown-toggle">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img
                        src="/app-assets/images/icon-more.png"
                        alt="Dropdown icon"
                        className="dropdown-icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-v2 arrow"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="block-iconmm vertical-layout">
                        {nophaithu_giahannophaithu && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalGiaHanNoPhaiThuShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gia-han.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gia hạn</span>
                          </a>
                        )}

                        {nophaithu_nhantin && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiTinNhan}
                          >
                            <PopoversBootrap
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-tin-nhan.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Nhắn tin</span>
                          </a>
                        )}

                        {nophaithu_guiemail && showSendMail == 1 && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiEmail}
                          >
                            <PopoversBootrap
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gui-mail.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gửi Email</span>
                          </a>
                        )}
                        {nophaithu_ghichunophaithu && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalGhiChuShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-ghi-chu.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Ghi chú</span>
                          </a>
                        )}
                        {nophaithu_doitinhtranghopdong && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalDoiTinhTrangNoShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi tình trạng nợ"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-doi-tinh-trang-no.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">
                              Đổi tình trạng nợ
                            </span>
                          </a>
                        )}
                        {isQRThanhToan && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalQRThanhToanShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              contentText="QR thanh toán"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                src="/app-assets/images/icon-qrcode-v2.png"
                                hidden={!isQRThanhToan}
                              />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">QR code</span>
                          </a>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    });
  }

  onChangeData = (field, event) => {
    let { dataSearch } = this.state;
    if (field == "customerName") {
      var arr = event.target.value.split("|");
      if (arr.length == 7) {
        dataSearch.pageIndex = 1;
        dataSearch.customerName = arr[0];
        this.loadNoPhaiThu(dataSearch);
      } else {
        dataSearch[field] = event.target.value;
      }
    } else {
      dataSearch[field] = event.target.value;
    }
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadNoPhaiThu(dataSearch);
    }
  };
  onChangeDate = (field) => (evt) => {
    let { dataSearch } = this.state;
    dataSearch[field] = formatDayMonth(evt);
    this.setState({ dataSearch });
  };
  onKeyDownDate = (field) => (evt, evt1) => {
    let { dataSearch } = this.state;
    if (evt.keyCode === 8) dataSearch[field] = "";
    this.setState({ dataSearch });
  };
  toggleModalThietLapHienThi() {
    this.setState({
      isShowModalThietLapHienThi: !this.state.isShowModalThietLapHienThi,
    });
  }
  setModalThietLapHienThi = () => () => {
    this.toggleModalThietLapHienThi();
  };

  render() {
    let { showTKNangCao, dataSearch, choVay, showTatToan } = this.state;
    let {
      showDongLai,
      showChiTietKhachHang,
      showChiTietHopDong,
      showModalTaiSan,
      taiSanId,
      showDoiTinhTrangNo,
      objThietLapHienThiDanhSach,
    } = this.state;
    let {
      user,
      nophaithu,
      inthuchi,
      phanquyen,
      giahannophaithu,
      ghichuchovay,
      cauhinh,
    } = this.props;

    let { getListNoPhaiThuLoading, objList } = nophaithu;
    let {
      TongNo,
      TotalMoney,
      TotalNoGoc,
      TotalNoLai,
      TotalQuantity,
      TotalPhiKhacHangKy,
    } = objList;
    let { inThuChiShow } = inthuchi;
    let {
      chonngaygiaodich,
      nophaithu_laisuat,
      nophaithu_indanhsachnophaithu,
      nophaithu_xuatexceldanhsachnophaithu,
      thuchihopdong_xoaphieuthuchi,
      nophaithu_tattoannophaithu,
      nophaithu_thanhtoannophaithu,
      nophaithu_suatientattoan,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungPhiPhat_DongLai_Cham,
      SuDungMaNhanVien,
      SuDungTachNoXau,
    } = phanquyen.PhanQuyenNoPhaiThu;
    let {
      debt,
      customerName,
      kieuvay,
      typeNgayPhaiTra,
      optionDateMB,
      dateTo,
      code,
      address,
      userName,
      trangThaiGiaHan,
      tienVay,
      sapxep,
    } = dataSearch;
    optionDateMB = convertDate(optionDateMB);
    let { showGiaHanNoPhaiThu } = giahannophaithu;
    let { showGhiChuChoVay } = ghichuchovay;
    let { PhiKho } = cauhinh.objConfig;
    // let link =
    //   configs.endPoint +
    //   `quanlychovay/no-phai-thu-xuat-excel?tenKhachHang=${customerName}&kieuvay=${kieuvay}&tienVay=${tienVay}&maTaiSan=${code}&user=${userName}&debtLevel=${debt}&trangThaiGiaHan=${trangThaiGiaHan}&diaChi=${address}&denNgay=${dateTo}&typeNgayPhaiTra=${typeNgayPhaiTra}&optionDateMB=${optionDateMB}`;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div
                      className="col-sm-12  col-md-9 title-cd"
                      style={{ marginTop: "-10px" }}
                    >
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-no-phai-thu.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Nợ phải thu</h1>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main">
                      <div className="display-ruby">
                        {nophaithu_indanhsachnophaithu && (
                          <span>
                            {/* <PrintData link={link}></PrintData> */}
                            <BtnInDanhSach dataSearch={dataSearch} />
                          </span>
                        )}
                        {nophaithu_xuatexceldanhsachnophaithu && (
                          <span>
                            {" "}
                            <BtnXuatExcel dataSearch={dataSearch} />
                            {/* <a
                                href={() => false}
                                onClick={this.xuatExcel()}
                                className="icon-bgnew color-print1"
                              >
                                <i className="mdi mdi-download"></i>
                              </a> */}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div className="search-new">
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tìm kiếm
                        </label>
                        <input
                          id="customer-name"
                          type="text"
                          className="form-control input-sm"
                          placeholder="Thông tin khách hàng/ Mã tài sản"
                          onChange={this.onChangeData.bind(
                            this,
                            "customerName"
                          )}
                          onKeyDown={this.handleKeyDown}
                          value={customerName}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Trạng Thái
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("debt")}
                          options={
                            SuDungTachNoXau
                              ? this.state.listTinhTrangNo.filter(
                                  (item) =>
                                    item.value !== 50 && item.value !== "50"
                                )
                              : this.state.listTinhTrangNo
                          }
                          placeholder="Tất cả"
                          controlClassName="form-control input-sm"
                          arrowClassName=""
                          value={debt}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="loan-type"
                          className="font-color-default font-bold"
                        >
                          Kiểu vay
                        </label>
                        <ReactDropdown
                          id="loan-type"
                          options={ChoVayCombo.KieuVayCombo1}
                          placeholder="-- Kiểu vay --"
                          controlClassName="form-control input-sm"
                          onChange={this._onSelect("kieuvay")}
                          value={kieuvay}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="loan-type"
                          className="font-color-default font-bold"
                        >
                          Ngày phải trả
                        </label>
                        <ReactDropdown
                          id="loan-type"
                          options={ChoVayCombo.NgayTraCombo}
                          placeholder="-- Ngày phải trả --"
                          controlClassName="form-control input-sm"
                          onChange={this._onSelect("typeNgayPhaiTra")}
                          value={typeNgayPhaiTra}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="loan-type"
                          className="font-color-default font-bold"
                        >
                          Sắp xếp
                        </label>
                        <ReactDropdown
                          id="loan-type"
                          options={ChoVayCombo.SapXepCombo}
                          placeholder="-- Sắp xếp --"
                          controlClassName="form-control input-sm"
                          onChange={this._onSelect("sapxep")}
                          value={sapxep}
                        />
                      </div>

                      {typeNgayPhaiTra === "4" && (
                        <div className="input-sm-new input-new-18">
                          <DateTimePicker
                            value={optionDateMB}
                            onChange={this.onChangeDate("optionDateMB")}
                            onKeyDown={this.onKeyDownDate("optionDateMB")}
                            placeholder="Ngày phải trả"
                          ></DateTimePicker>
                        </div>
                      )}

                      {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                        SuDungMaNhanVien && (
                          // <div className="input-sm-new input-new-18">
                          //   <ReactDropdown
                          //     onChange={this._onSelect("manhanvien")}
                          //     // options={ChoVayCombo.TinhTrangCombo}
                          //     options={this.state.listNhanVien}
                          //     placeholder="Chọn nhân viên"
                          //     controlClassName="form-control input-sm"
                          //     value={dataSearch.manhanvien}
                          //   />
                          // </div>
                          <div className="input-sm-new input-new-18">
                            <label
                              htmlFor="loan-type"
                              className="font-color-default font-bold"
                            >
                              Chọn nhân viên
                            </label>
                            <ReactDropdown
                              id="loan-type"
                              options={this.state.listNhanVien}
                              placeholder="-- Nhân viên --"
                              controlClassName="form-control input-sm"
                              onChange={this._onSelect("manhanvien")}
                              value={dataSearch.manhanvien}
                            />
                          </div>
                        )}
                      <div className="input-sm-new input-new-18 search-main-new">
                        <button
                          type="submit"
                          className="btn btn-info-new btn-seach-ds"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i> &nbsp;
                          <span class="search-label">Tìm kiếm</span>
                        </button>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setTKNangCaoModalShow}
                        >
                          <i>
                            <img
                              className="icon-bred-home"
                              src="/app-assets/images/icon-fitter-v2.png"
                              alt=""
                              style={{ scale: "0.9", verticalAlign: "sub" }}
                            />
                          </i>
                        </a>

                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setModalThietLapHienThi()}
                          style={{ marginLeft: 55 }}
                        >
                          <i
                            className="fa fa-cog icon-bred-home"
                            style={{
                              scale: "0.9",
                              verticalAlign: "sub",
                              height: 30,
                            }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div data-repeater-item className="">
                      <form className="search-full form row bg-search-form form-mobile-search">
                        <div className="text-right left-search search-p mb-1 ">
                          <div className="form-search-mobile-new row">
                            <div
                              className="left-search-mobile-new"
                              style={{ width: "85%" }}
                            >
                              <div className="search-mobile-new">
                                <fieldset className="form-group position-relative mb-0">
                                  <input
                                    type="text"
                                    className="form-control input-sm"
                                    id="iconLeft1"
                                    placeholder="Tên, mã, sđt khách hàng ..."
                                    onChange={this.onChangeData.bind(
                                      this,
                                      "customerName"
                                    )}
                                  />
                                  <div
                                    className="form-control-position"
                                    onClick={this.onSearch}
                                  >
                                    <i className="mdi mdi-magnify"></i>
                                  </div>
                                </fieldset>
                              </div>
                            </div>
                            <div className="right-search-mobile-new">
                              <div class="icon-search-mobile">
                                <a
                                  href={() => false}
                                  className="card-link blue darken-2"
                                  onClick={this.setTKNangCaoModalShow}
                                >
                                  <i>
                                    <PopoversBootrap
                                      contentText="Tìm kiếm nâng cao"
                                      trigger={["hover", "focus"]}
                                      placement={"top"}
                                    >
                                      <img
                                        className="icon-bred-home"
                                        src="/app-assets/images/icon-fitter-v2.png"
                                        alt=""
                                        style={{
                                          scale: "0.9",
                                          verticalAlign: "sub",
                                          marginTop: "-2px",
                                        }}
                                      />
                                    </PopoversBootrap>
                                  </i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="card border-light mb-3 card-v2"
              style={{
                marginLeft: "15px",
                marginRight: "15px",
                marginTop: "-25px",
              }}
            >
              <div className="card-body card-body-v2">
                <div className="Left808x200 Table-main-new">
                  <div className="loading-page1">
                    <div
                      className={
                        "loader loader-default " +
                        (getListNoPhaiThuLoading ? "is-active" : "")
                      }
                    ></div>
                  </div>
                  <div className="table-mobile sticky-table-bh2 sticky-table-bh table-mobile-hover">
                    <div className="custom-table-wrapper css-table-ds">
                      <div className="table-headers">
                        {objThietLapHienThiDanhSach.IsAnSTT != true && (
                          <div className="custom-table-header flex-basis-5 flex-basis-6-sm-npt flex-basis-6-npt">
                            <p className="text-center">
                              STT
                              <br />{" "}
                              <span className="color-do-bold">
                                [{TotalQuantity}]
                              </span>
                            </p>
                          </div>
                        )}{" "}
                        {objThietLapHienThiDanhSach.IsAnMaHD != true && (
                          <div className="custom-table-header flex-basis-11 flex-basis-11-6-sm-npt flex-basis-10-6-npt center-flex">
                            <p>Mã hợp đồng</p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnTSTheChap != true && (
                          <div className="custom-table-header flex-basis-10 flex-basis-9-sm">
                            <p className="text-left">TS thế chấp</p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnTenKH != true && (
                          <div className="custom-table-header flex-basis-12  flex-basis-11-8-sm-npt flex-basis-11-8-npt">
                            <p>Tên khách hàng</p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                          SuDungMaNhanVien && (
                            <div className="custom-table-header flex-basis-6  flex-basis-11-8-sm-npt flex-basis-8-8-npt">
                              <p>Nhân viên</p>
                            </div>
                          )}
                        {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
                          this.state.isCauHinhKhachHangBinhAn == false && (
                            <div className="custom-table-header flex-basis-11 flex-basis-11-sm-npt flex-basis-10-8-npt">
                              <p className="text-right">
                                Số tiền vay
                                <br />
                                {/*  </i>= */}
                                <span
                                  className="color-do-bold"
                                  title={formatNumber(TotalMoney)}
                                >
                                  {formatCurrency(TotalMoney)}
                                </span>
                              </p>
                            </div>
                          )}
                        {this.state.isCauHinhKhachHangBinhAn == true && (
                          <div className="custom-table-header flex-basis-11 flex-basis-11-sm-npt flex-basis-10-8-npt">
                            <p className="text-right">
                              Tiền đưa khách
                              <br />
                              {/*  </i>= */}
                              <span
                                className="color-do-bold"
                                title={formatNumber(TotalMoney)}
                              >
                                {formatCurrency(TotalMoney)}
                              </span>
                            </p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnNoLai != true && (
                          <div className="custom-table-header flex-basis-11 flex-basis-11-sm-npt flex-basis-11-4-npt">
                            <p className="text-right">
                              Nợ lãi
                              <br />
                              {/*  </i>= */}
                              <span
                                className="color-xanh-bold"
                                title={formatNumber(TotalNoLai)}
                              >
                                {formatCurrency(TotalNoLai)}
                              </span>
                            </p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnPhiHangKy != true && (
                          <div className="custom-table-header flex-basis-9 flex-basis-9-sm-npt flex-basis-9-4-npt">
                            <p className="text-right">
                              Phí hàng kỳ
                              <br />
                              {/*  </i>= */}
                              <span
                                className="color-tim-bold"
                                title={formatNumber(TotalPhiKhacHangKy)}
                              >
                                {formatCurrency(TotalPhiKhacHangKy)}
                              </span>
                            </p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnNoGoc != true && (
                          <div className="custom-table-header flex-basis-9 flex-basis-11-sm-npt flex-basis-11-2-npt">
                            <p className="text-right">
                              Nợ gốc <br />
                              {/*   */}
                              <span
                                className="color-cam-bold"
                                title={formatNumber(TotalNoGoc)}
                              >
                                {formatCurrency(TotalNoGoc)}
                              </span>
                            </p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnTongNo != true && (
                          <div className="custom-table-header flex-basis-11 flex-basis-11-sm-npt flex-basis-11-8-npt">
                            <p className="text-right">
                              Tổng nợ
                              <br />
                              <PopoversBootrap
                                contentText={formatNumber(TongNo)}
                                trigger={["hover", "focus"]}
                                placement={"bottom"}
                              >
                                <span className="color-do-bold">
                                  {formatCurrency(TongNo)}
                                </span>
                              </PopoversBootrap>
                            </p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnLyDo != true && (
                          <div className="custom-table-header flex-basis-10 flex-basis-11-2-sm-npt flex-basis-8-4-npt">
                            <p className="tab-header text-left">Lý do</p>
                          </div>
                        )}
                        {objThietLapHienThiDanhSach.IsAnChucNang != true && (
                          <div className="custom-table-header flex-basis-8 flex-basis-7-sm-npt flex-basis-7-npt action-cell">
                            <p className="tab-header text-center ">Chức năng</p>
                            <br />
                          </div>
                        )}
                      </div>

                      <div className="curenderTableRowsstom-table-body">
                        {this.renderTableRows()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="card border-light mb-3 card-v2"
              style={{
                marginLeft: "15px",
                marginRight: "15px",
                marginTop: "-25px",
              }}
            >
              <div className="card-body card-body-v2">
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <span className="color7">
                      {TotalQuantity === 0 ? (
                        "Hiển thị 0 - 0 / Tổng số 0"
                      ) : (
                        <>
                          Hiển thị{" "}
                          {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1}{" "}
                          -{" "}
                          {Math.min(
                            dataSearch.pageIndex * dataSearch.pageSize,
                            TotalQuantity
                          )}{" "}
                          / Tổng số {TotalQuantity}
                        </>
                      )}
                    </span>
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <div
                      className={
                        "paniation-new paniation-new1 d-flex justify-content-center " +
                        (TotalQuantity === 0 ? "hidden" : "")
                      }
                      style={{ float: "right" }}
                    >
                      <nav aria-label="Page navigation">
                        <Pagination
                          activePage={dataSearch.pageIndex}
                          itemsCountPerPage={dataSearch.pageSize}
                          totalItemsCount={TotalQuantity}
                          pageRangeDisplayed={5}
                          onChange={this.handlePageChange}
                          itemClass="page-item border-none"
                          linkClass="page-link border-none"
                          activeClass="active"
                        />
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <SearchNoPhaiThu
              data={dataSearch}
              show={showTKNangCao}
              onHide={this.setTKNangCaoModalShow}
              userCombo={user.combo}
              listTinhTrangNo={this.state.listTinhTrangNo}
            ></SearchNoPhaiThu>
            {showGhiChuChoVay && (
              <GhiChuChoVayContainer
                show={showGhiChuChoVay}
                onHide={this.setModalGhiChuShow(null)}
                data={choVay}
              ></GhiChuChoVayContainer>
            )}

            {showGiaHanNoPhaiThu && (
              <GiaHanNoPhaiThuContainer
                data={choVay}
                show={showGiaHanNoPhaiThu}
                onHide={this.setModalGiaHanNoPhaiThuShow(null)}
              ></GiaHanNoPhaiThuContainer>
            )}

            {showTatToan && (
              <TatToanContainer
                show={showTatToan && !inThuChiShow}
                data={choVay}
                onHide={this.setModalTatToanShow(choVay)}
                chonngaygiaodich={chonngaygiaodich}
                isShowPhiKho={PhiKho}
                quyenSuaTienTatToan={nophaithu_suatientattoan}
                buttonLeft={
                  <ButtonChuyenForm
                    quyenDongLai={nophaithu_thanhtoannophaithu}
                    showDongLai={this.setDongLaiModalShow(choVay)}
                  ></ButtonChuyenForm>
                }
              ></TatToanContainer>
            )}
            {showDongLai && (
              <DongLaiContainer
                show={
                  showDongLai &&
                  !inThuChiShow &&
                  !this.state.isShowSuaKyLai &&
                  !this.state.isShowInDanhSachDongLai
                }
                onHide={this.setDongLaiModalShow(choVay)}
                onShowPhieuThu={this.setInThuChiModalShow}
                onShowSuaKyLai={this.setSuaKyLaiModalShow}
                onShowInDanhSachDongLai={this.setInDanhSachDongLaiShow}
                data={choVay}
                thaydoitienlai={nophaithu_laisuat}
                chonngaygiaodich={chonngaygiaodich}
                xoaphieuthuchi={thuchihopdong_xoaphieuthuchi}
                SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
                SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                isShowPhiKho={PhiKho}
                buttonLeft={
                  <ButtonChuyenForm
                    // showDongLai={this.setDongLaiModalShow(choVay)}
                    quyenTatToan={nophaithu_tattoannophaithu}
                    showTatToan={this.setModalTatToanShow(choVay)}
                  ></ButtonChuyenForm>
                }
              ></DongLaiContainer>
            )}

            {this.state.isShowSuaKyLai && (
              <ModalSuaKyLai
                show={this.state.isShowSuaKyLai}
                onHide={this.setSuaKyLaiModalShow()}
                data={this.state.dataSuaKyLai}
                dataTotal={this.state.dataTotalDongLai}
                getLanDongLaiChoVay={this.props.getLanDongLaiChoVay}
              />
            )}
            {this.state.isShowInDanhSachDongLai && (
              <ModalInDanhSachDongLai
                show={this.state.isShowInDanhSachDongLai}
                onHide={this.setInDanhSachDongLaiShow()}
                data={this.state.dataInDanhSachDongLai}
              />
            )}

            {inThuChiShow && (
              <InThuChiContainer
                show={inThuChiShow}
                onHide={this.setInThuChiModalShow()}
              ></InThuChiContainer>
            )}
            {showChiTietHopDong && (
              <ChiTietHopDongContainer
                show={showChiTietHopDong && !showModalTaiSan}
                onHide={this.setModalChiTietHopDongShow(choVay)}
                data={choVay}
                setModalTaiSan={this.setModalTaiSan}
              ></ChiTietHopDongContainer>
            )}
            {showDoiTinhTrangNo && (
              <DoiTinhTrangNoContainer
                show={showDoiTinhTrangNo}
                onHide={this.setModalDoiTinhTrangNoShow(choVay)}
                data={choVay}
              ></DoiTinhTrangNoContainer>
            )}
            <GuiEmailContainer data={choVay}></GuiEmailContainer>
            <TinNhanContainer data={choVay}></TinNhanContainer>
            {showChiTietKhachHang && (
              <CustomerDetail
                show={showChiTietKhachHang && !showChiTietHopDong}
                onHide={this.setModalChiTietKhachHangShow(choVay)}
                showChiTietHopDong={this.setModalChiTietHopDongShow}
                data={choVay}
              ></CustomerDetail>
            )}
            {showModalTaiSan && (
              <ChiTietTaiSanContainer
                show={showModalTaiSan}
                taiSanId={taiSanId}
                onHide={this.setModalTaiSan()}
              ></ChiTietTaiSanContainer>
            )}
            {this.state.showModalThongBao && (
              <ModalThongBaoKhiDangNhap
                show={this.state.showModalThongBao}
                onHide={this.toggleModal.bind(this)}
              />
            )}
            {this.state.isShowModalQRThanhToanHD && (
              <ModelQRThanhToanHD
                show={this.state.isShowModalQRThanhToanHD}
                onHide={this.toggleModalQRThanhToanHD.bind(this)}
                hopdong={this.state.itemDataQR}
                Value={this.state.TienThanhToan}
              />
            )}
            {this.state.isShowModalThietLapHienThi && (
              <ModelThietLapHienThi
                show={this.state.isShowModalThietLapHienThi}
                onHide={this.toggleModalThietLapHienThi.bind(this)}
                data={this.state.objThietLapHienThiDanhSach}
                SuDungMaNhanVien={SuDungMaNhanVien}
                getThietLapHienThi={this.getThietLapHienThi.bind(this)}
              />
            )}

            {/* {this.state.showThongBaoHetHan && (
          <ModalThongBaoHetHan
            show={this.state.showThongBaoHetHan}
            onHide={this.toggleModalHetHan.bind(this)}
            value={this.state.dateHetHan}
          />
        )} */}
          </div>
        </div>
      </LayoutV2>
    );
  }
}

NoPhaiThu.propTypes = {
  getList: PropTypes.func,
};

export default NoPhaiThu;
